import React, { Component } from 'react';

class CancelarEdicionActualModal extends Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(value){
        if(value == "aceptar"){
            this.props.toggleModal("CancelarEdicionActual");
            this.props.buscarPorCuit(this.props.buscarCliente,true);
            //this.props.toggleModal("SolicitudAltaDeCuenta");
            this.props.abrirModalDatos();
        }else{
            this.props.toggleModal("CancelarEdicionActual");
        }
    }
    
    render() {
        const {integrante} = this.props;       
        
        return (
                <div className="modal fade-out" id="CancelarEdicionActual" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" data-backdrop="static">
                    <div className="modal-dialog">
                            <div className="modal-content modal-wide">
                                <div className="modal-header-new">
                                    <div className="closeNew" data-dismiss="modal" aria-hidden="true"><label className="ti-close clickable"></label></div>
                                    <h2 className="modal-title-new" id="myModalLabel">Cancelar Edición</h2>
                                </div>
                                <div className="modal-body-new">{"¿Está seguro que quiere desestimar el alta/modificación del integrante " + integrante + " ?" }</div>
                                <div className="modal-footer-new">
                                    <button className="btn btn-cta" onClick={()=>this.handleClick("aceptar")} >Sí</button>
                                    <button className="btn btn-secondary button-separation-foot" onClick={()=>this.handleClick("cancelar")}>No</button>
                                </div>
                        </div>
                    </div>
                </div>
        );
    }
};

export default CancelarEdicionActualModal